var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2478",
    "data-name": "Group 2478",
    transform: "translate(359 -4736)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1581",
    "data-name": "Rectangle 1581",
    width: 15,
    height: 15,
    transform: "translate(-359 4736)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2463",
    "data-name": "Group 2463",
    transform: "translate(-359 4736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1860",
    "data-name": "Group 1860"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M14.625,13.5H14.25V5.25a.709.709,0,0,0-.75-.75V3.75A.709.709,0,0,0,12.75,3H10.875L7.5,0,3.75,3H2.25a.709.709,0,0,0-.75.75V4.5a.709.709,0,0,0-.75.75V13.5H.375A.354.354,0,0,0,0,13.875v.75A.354.354,0,0,0,.375,15h14.25A.354.354,0,0,0,15,14.625v-.75A.354.354,0,0,0,14.625,13.5Zm-7.35-12a.709.709,0,0,1,.75.75.709.709,0,0,1-.75.75.752.752,0,0,1-.75-.75A.709.709,0,0,1,7.275,1.5ZM4.5,12H2.25V9.75H4.5Zm0-3.75H2.25V6H4.5ZM9,13.5H6V11.25a1.5,1.5,0,1,1,3,0ZM9,8.25H6V6H9ZM12.75,12H10.5V9.75h2.25Zm0-3.75H10.5V6h2.25Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/school.f58e20f963534d195f35fd84f91c2f07.svg";
export { ForwardRef as ReactComponent };